interface ScreenReaderMessageHandlerType {
    (screenReaderMessage: string): void;
}

export class ScreenReaderService {

    public static instance = new ScreenReaderService();

    private screenReaderMessage: string;
    private screenReaderMessageHandlers: ScreenReaderMessageHandlerType[];

    constructor() {
        this.screenReaderMessage = '';
        this.screenReaderMessageHandlers = [];
    }

    public addScreenReaderMessageHandler(announceScreenReaderMessage: ScreenReaderMessageHandlerType)
    {
        this.screenReaderMessageHandlers.push(announceScreenReaderMessage);
    }

    public removeScreenReaderMessageHandler(announceScreenReaderMessage: ScreenReaderMessageHandlerType)
    {
        this.screenReaderMessageHandlers = this.screenReaderMessageHandlers.filter((screenReaderMessageHandler: ScreenReaderMessageHandlerType) => screenReaderMessageHandler !== announceScreenReaderMessage);
    }

    public setScreenReaderMessage(message: string) {
        this.screenReaderMessage = message;
        this.notifyStatusMessages();
    }

    public notifyStatusMessages() {
        this.screenReaderMessageHandlers.forEach((announceStatusMessage: ScreenReaderMessageHandlerType) => {
                announceStatusMessage(this.screenReaderMessage);
        });
    }
}